// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import Vuex from 'vuex'

import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Echarts from 'echarts/lib/echarts'
import lodash from 'lodash'
// TODO: 准备逐步移除vueresource
import store from './store'

import 'babel-polyfill'
Vue.prototype.$_ = lodash
Vue.use(Vuex)

// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://enterprise.zhihuituancan.com/apiv1/'
} else {
  baseUrl = 'https://testmanagement.zhihuituancan.com/apiv1/'
  // baseUrl = 'https://enterprise.zhihuituancan.com/apiv1/'
}
//

Vue.prototype.$echarts = Echarts
Vue.use(Element, {
  size: 'medium' // set element-ui default size
})
Vue.config.productionTip = false
// let host = "http://121.41.92.64:7705/"
Vue.prototype._host = baseUrl
/* eslint-disable no-new */
new Vue({
  router,
  store,
  data () {
    return {
      eventHub: new Vue()
    }
  },
  render: h => h(App)
}).$mount('#app')
